import fireConfetti, { Options as CanvasOptions } from "canvas-confetti";

const DEFAULT_COLORS = ["#80B22D", "#CC8634", "#EF4E77", "#4C47CC", "#4462EF"];

const DEFAULT_OPTIONS = {
  particleCount: 100,
  spread: 70,
  zIndex: 200,
  colors: DEFAULT_COLORS,
};

type Origin = { x: number; y: number };
type ConfettiCanonProps = { origin: Origin } & Partial<
  Omit<CanvasOptions, "origin">
>;

const confettiCanon = ({ origin, ...options }: ConfettiCanonProps) => {
  fireConfetti({
    ...DEFAULT_OPTIONS,
    origin,
    ...options,
  });
};

export default confettiCanon;
